

import React from 'react';
import {withRouter, useLocation } from 'react-router-dom';
import {connect} from 'react-redux';
import GeneralTile from '../../Common/GeneralTile';
import Row from "react-bootstrap/Row";
import placeholder from '../../../assets/images/placeholder-person.png';
import * as tableActions from '../../../store/actions/table';
import {PeopleCircleOutline} from 'react-ionicons';
import Col from "react-bootstrap/Col";
import PageLoader from "../../Common/PageLoader";
import SearchField from '../../Common/SearchField'
import BaseFilterPage from '../BaseFilterPage'


class Teams extends BaseFilterPage {

    constructor(props) {
        super(props);
        // Nothing to add to state in this case
    }

    fetchData(inputText) {
        let eventId = this.props.match?.params?.id;
        let teamQuery = {event: eventId};

        if (inputText) {
            // Add search text to query for event name field. regex gives us a substring match, "i" option for case insensitive
            teamQuery.label = { "$regex": inputText, "$options": "i" };
            // I hate one offs like this, but schoolName will have special handling in the backend
            teamQuery.schoolName = inputText;
        }

        this.props.getTeamsDataWithQuery(teamQuery, this.props.auth.token._id);
    }

    render() {

        let eventId = this.props.match?.params?.id;

        // Use event name for the header if available
        let headerText = this.props.table.data && this.props.table.data[0] ? 
            this.props.table.data[0].event?.name ?? 'My Teams' : 'My Teams';
        return (
            <div className={"page-container-slim"}>
                <PageLoader loaded={!this.props.table.tableLoading}>
                    <div className={'page-header'}>
                        <Row>
                            <Col>
                                <h1><PeopleCircleOutline />{headerText}</h1>
                                <SearchField onBlurValue={this.handleInputBlur} />
                            </Col>
                        </Row>
                    </div>
                    <div className={"section"}>

                        <div className={"tile-grid"}>
                            <Row>
                                <GeneralTile new={true} label={"Create Team"} index={this.props.table.data.length} onAddNew={e => this.props.history.push(`/app/teams/${eventId}/team/new`)} />
                                {this.props.table.data.map((d, i) => {
                                    return <GeneralTile collection={"teams"} {...d} key={i} index={i} data={d} placeholder={placeholder} />
                                })}
                            </Row>
                        </div>
                    </div>

                </PageLoader>




            </div>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    table: state.table,
    user: state.user
});

const mapDispatchToProps = dispatch => ({
    getTeamsDataWithQuery: (query, token) => {
        dispatch(tableActions.getTableDataWithQuery("teams", 0, 99, {}, query, token, "add"));
    },
    getStudents: (token) => {
        dispatch(tableActions.getStudents(0, 99, {}, token, "add"));
    },
});

const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(Teams));

class TeamsContainer extends React.Component {
    render() {
        return (
            <div>
                <Connected/>
            </div>
        )
    }
}

export default TeamsContainer;
